import React, {useCallback, useMemo} from 'react'
import {ChatMessage, Hub} from 'yougile-model'
import {ChatUtils} from '@extensions/chat-utils'

export const useReplyTarget = (
  msg: ChatMessage,
  hub?: Hub
): {
  replyTarget?: ChatMessage
  goToReplyTarget: (e: React.MouseEvent) => void
} => {
  const replyTarget = useMemo(() => {
    const t = msg.getReplyTo()
    return t ? hub?.chat.messages.get(t) : undefined
  }, [msg, hub])

  const goToReplyTarget = useCallback(
    (e: React.MouseEvent) => {
      if (!replyTarget) {
        return
      }
      const target = e.target as HTMLElement
      if (target?.nodeName === 'IMG') {
        e.preventDefault()
      }
      if (hub) {
        ChatUtils.openChat(hub, {messageTime: replyTarget.timestamp})
      }
    },
    [replyTarget, hub]
  )

  return {replyTarget, goToReplyTarget}
}
